import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { useAuthedApi } from "./api";

// Global browsing location chosen in the top bar: { state, city } — city "" = whole state, state "" = All India.
const KEY = "csm_location";
const LocCtx = createContext({ location: null, setLocation: () => {}, askOpen: false, setAskOpen: () => {} });

const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; } };
const store = (v) => localStorage.setItem(KEY, JSON.stringify(v || { state: "", city: "" }));

export const locLabel = (l) => l?.city || l?.state || (l ? "All India" : "Select city");
export const locParams = (l) => (l?.state ? (l.city ? { state: l.state, city: l.city } : { state: l.state }) : {});

export function LocationProvider({ children }) {
  const { isSignedIn } = useAuth();
  const api = useAuthedApi();
  const [location, setLoc] = useState(read);
  const [askOpen, setAskOpen] = useState(false);

  const setLocation = useCallback((v) => {
    const next = { state: v?.state || "", city: v?.city || "" };
    setLoc(next);
    store(next);
    if (isSignedIn && next.city) api("put", "/me/location", next).catch(() => {});
  }, [isSignedIn, api]);

  useEffect(() => {
    // Account city is only adopted on a device that has never picked a location.
    if (!isSignedIn) return;
    api("get", "/me").then((me) => {
      const saved = me.location;
      const local = read();
      if (!local && saved?.city) { setLoc(saved); store(saved); }
      else if (local?.city && (local.city !== saved?.city || local.state !== saved?.state)) api("put", "/me/location", local).catch(() => {});
    }).catch(() => {});
  }, [isSignedIn]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const sync = (e) => e.key === KEY && setLoc(read());
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);
  return <LocCtx.Provider value={{ location, setLocation, askOpen, setAskOpen }}>{children}</LocCtx.Provider>;
}

export const useUserLocation = () => useContext(LocCtx);
